<script>
    import { mapGetters } from 'vuex'
    import { inventoryMethods, warehouseMethods, pendingsMethods } from '@state/helpers'
    
    export default {
      name: 'Pointer',
      props: {
        restorePendings: {
          type: Boolean,
          required: false,
          default: false
        }
      },
      components: {},
      data() {
        return {
          resetModalShow:false,
          loadingReset:false

        }
      },
      computed: {
        ...mapGetters({
          own_consult_warehouse: 'retina/warehouse/own_consult_warehouse',
          own_warehouse_i: 'retina/inventory/own_warehouse_i',
          own_warehouse_selected: 'retina/warehouse/own_warehouse_selected',
          own_inventory_count_mode: 'retina/inventory/own_inventory_count_mode',
            own_inventory_count_review: 'retina/inventory/own_inventory_count_review',
          own_inventory_online_mode: 'retina/inventory/own_inventory_online_mode',
        }),
      },
      methods: {
        ...inventoryMethods,
        ...warehouseMethods,
        ...pendingsMethods,
        statusInfo(value) {
          return (
            (value ? 'outline-success' : 'outline-secondary') + ' btn-transparent'
          )
        },
        async reset() {
          if(this.restorePendings === true){
            this.deletePendings()
          }
          this.$store.dispatch('retina/warehouse/clearOwnWarehouse')
          this.setOwnWarehouseI(null)
          this.enableOwnInventoryCountMode()
          this.clearOwnInventory()
          this.setOwnStock([])
          this.clearOwnPending()
          this.setOwnTotalPending(0)
          this.disableOwnInventoryCountMode()
          this.setOwnInventoryOnlineMode(false)
          this.setOwnInventoryCountReview(false)
          this.setConsultWarehouse(true)
        },
        consultWarehouse() {
          return !this.own_warehouse_selected ? true 
                  : this.own_inventory_count_mode ? false
                  : this.own_inventory_count_review ? false
                  : this.own_inventory_online_mode ? false : true
        },
        async deletePendings(){
          let response = await this.deleteAllPendings(
            '?id_warehouse=' + this.own_warehouse_i.id +
            '&id_location=')
          console.log(response)
          if(response){
            if(response.count_deleted > 0){
              this.$generate_toast(this, 'success', `Se han limpiado los pendientes satisfactoriamente!`);
            } else {
              this.$generate_toast(this, 'warn', `No hay registros pendientes por limpiar, verifique`);
            }
            return true
          } else {
            this.$generate_toast(this, 'error', `Hubo un error intentando limpiar, reintente`);
            console.error("error", response)
          }
          return false
        }
      },
      beforeMount() {
        if (!this.own_warehouse_selected){
          this.setOwnInventoryOnlineMode(false)
        }
      },
    }
    </script>
    <template>
      <b-row class="d-flex justify-content-between mb-2">
        <b-col xs="12" sm="12" md="12">
          <div v-if="!restorePendings" class="p-0 m-0 d-inline">
            <b-button
              v-if="consultWarehouse()"
              variant="link"
              disabled
            >
              
              <span v-if="!own_warehouse_selected && !own_warehouse_i" class="text-danger"><i class="fa fa-exclamation-triangle"></i> Seleccionar bodega</span>
              <span v-else-if="(own_warehouse_selected) || (own_warehouse_i)"  class="text-success"><i class="fas fa-check"></i> Bodega seleccionada</span>
    
            </b-button>
            <b-button
              v-if="own_inventory_online_mode && own_warehouse_selected"
              :variant="statusInfo(own_inventory_online_mode)"
              disabled
            >
              <i class="fas fa-globe-americas"></i>
              Consultar inventario online
            </b-button>
            <b-button
              v-if="own_inventory_count_mode"
              :variant="statusInfo(own_inventory_count_mode)"
              disabled
            >
              <i class="fas fa-dolly-flatbed"></i>
              Contar productos en bodega
            </b-button>
            <b-button
              v-if="own_inventory_count_review"
              :variant="statusInfo(own_inventory_count_review)"
              disabled
            >
              <i class="fas fa-clipboard-list"></i>
              Revisar Pedido
            </b-button>
          </div>
          <b-button @click="resetModalShow=true" size="sm" variant="outline-danger" class="float-right" :data-type="restorePendings">
            <span v-if="!restorePendings"> <i class="fas fa-stopwatch"></i> Restablecer</span>
            <span v-else ><i class="fas fa-undo"></i> Limpiar Pendientes</span>
          </b-button>
        </b-col>
        <!--Restablecer-->
        <b-modal
          id="reset-modal"
          v-model="resetModalShow"
          title="Restablecer Inventario"
          ok-title="Restablecer"
          ok-variant="danger"
          @hidden="resetModalShow=false"
          @ok="reset"
          @cancel="resetModalShow=false"
        >
          <p>
            ¿Esta seguro de Restablecer el Inventario? Los cambios realizados no se guardaran.
          </p>
          <template v-slot:modal-footer="{ ok, cancel }">
            <b-button size="sm" variant="secondary" @click="cancel">
              Cerrar
            </b-button>
            <b-button
              size="sm"
              variant="danger"
              :disabled="loadingReset"
              @click="ok"
            >
              <span v-if="!loadingReset">
                Restablecer
              </span>
              <b-spinner v-if="loadingReset" small label="Spinning" variant="light">
              </b-spinner>
            </b-button>
          </template>
        </b-modal>
      </b-row>
    </template>
    <style lang="scss">
      .multiselect__option {
        white-space: normal;
        font-weight: 300;
        font-size: 14px;
      }
    </style>
    